import SDK from "../SDK"
import { callbacks } from "../callback";
// import { API_URL } from "../processENV"
import { toast } from "react-toastify";
import { constructRosterData, formatUserIdToJid } from "../Helpers/Chat/User"
import {store} from "../Redux/store"
import { addGroupsData } from "../Redux/feature/groupsDataSlice"; 
import { addVCardData } from "../Redux/feature/userDataSlice"
import { addRosterData } from "../Redux/feature/rosterDataSlice";
import { addRecentChat } from "../Redux/feature/recentChatDataSlice"; 
import { addUnreadCount } from "../Redux/feature/unreadCountSlice";
import { encryptAndStoreInLocalStorage } from "../Helpers/Chat/webChatEncryptDecrypt";
import { addEnvData } from "../Redux/feature/envDataSlice";
import { CHAT_TYPE_GROUP } from "../Helpers/Chat/Constant";
import { setGroupParticipantsByGroupId } from "../Helpers/Chat/Group";
import { addActiveChatData } from "../Redux/feature/activeChatDataSlice";
import { addFeatureList } from "../Redux/feature/addFeatureDataSlice";
import { createLocalDB } from "../Helpers/localDB";
import { addMirrorflyInitialData } from "../Redux/feature/mirrorflyInitialDataSlice";
import { handleUserSettings, setTempMute } from "../Helpers/Chat/ChatHelper";
import { themeCustomization } from "../Helpers/Utility";
import { addAdminBlock } from "../Redux/feature/adminBlockUserSlice";


export const Initialization= async(props)=>{

    const {
        licenseKey,
        userIdentifier,
        profileName,
        // apiUrl,
        // isSandBox,
        colorSet,
        theme,
        iconSet,
        customConversation
    }=props
    const {
      connectionListener,
      messageListener,
      singleMessageDataListener,
      presenceListener,
      groupProfileListener,
      mediaUploadListener,
      userProfileListener,
      groupMsgInfoListener,
      incomingCallListener,
      callStatusListener,
      userTrackListener,
      callUserJoinedListener,
      callUserLeftListener,
      callSpeakingListener,
      muteStatusListener,
      muteChatListener,
      blockUserListener,
      mediaErrorListener,
      inviteUsersListener,
      missedCallListener,
      callSwitchListener,
      replyMessageListener,
      callUsersUpdateListener,
      adminBlockListener,
      helper } = callbacks
      themeCustomization(theme,colorSet,iconSet)
    const envs = {
        // "apiBaseUrl": apiUrl,
        "callbackListeners": {
          connectionListener,
          messageListener,
          singleMessageDataListener,
          presenceListener,
          groupProfileListener,
          mediaUploadListener,
          userProfileListener,
          groupMsgInfoListener,
          incomingCallListener,
          callStatusListener,
          userTrackListener,
          callUserJoinedListener,
          callUserLeftListener,
          callSpeakingListener,
          muteChatListener,
          blockUserListener,
          muteStatusListener,
          mediaErrorListener,
          inviteUsersListener,
          missedCallListener,
          callSwitchListener,
          replyMessageListener,
          callUsersUpdateListener,
          adminBlockListener,
          helper
        },
        "licenseKey": licenseKey,
        // "isSandbox": JSON.stringify(isSandBox)
    };
    store.dispatch(addEnvData({
      // apiBaseUrl:API_URL,
      licenseKey: licenseKey,
      // isSandbox: false
    }))
    
    handleSDKIntialize(envs,userIdentifier,licenseKey,customConversation,profileName)
    
}

const handleSDKIntialize = async(envs,userIdentifier,licenseKey,customConversation,profileName) => {
    const initializeObj = envs;
    
    const response = await SDK.initializeSDK(initializeObj);
    console.log("response",response)
    if(response.statusCode === 400)toast.error(response.message)
    let responseCall = { statusCode: 200 };
    if (response.statusCode === 200 && responseCall.statusCode === 200) {
        SDK.setMediaEncryption(true); //Enable the media encryption
        const registerResult = await SDK.register(userIdentifier);
        if(registerResult.statusCode === 400)toast.error(registerResult.message)
        const { statusCode="" } = registerResult
        if(statusCode === 403){
          store.dispatch(addAdminBlock({registerResult, isAdminBlocked: true}))
        }
        if(statusCode === 200){
            store.dispatch(addAdminBlock())
            handleLogin(registerResult?.data,licenseKey,customConversation,profileName)
          }
        }
      }
      
    const handleLogin = (response,licenseKey,customConversation,profileName)=>{
    let loginResponse = {
      username: response.username,
      password: response.password,
      type: "web"
    };
     SDK.connect(response.username, response.password)
      .then(async (res) => {
        if (res.statusCode === 200) {
         handleLoginSuccess(loginResponse,licenseKey,customConversation,profileName);
        }
      })
      .catch((error) => {
        console.log("handleLogin error, ", error);
      });

}

export const handleLoginSuccess = async(data,licenseKey,customConversation,profileName) => {
    encryptAndStoreInLocalStorage("auth_user", data);
    let resource = SDK.getCurrentUserJid();
    if (resource.statusCode === 200) encryptAndStoreInLocalStorage("loggedInUserJidWithResource", resource.userJid);

    const tokenResult = await SDK.getUserToken(data.username, data.password);
    if (tokenResult.statusCode === 200) encryptAndStoreInLocalStorage("userToken", tokenResult.userToken);
    encryptAndStoreInLocalStorage("recordingStatus", true);
    handleUserSettings();

    const userProfile = await SDK.getUserProfile(formatUserIdToJid(data.username));
      if(userProfile && userProfile?.data?.nickName === ""){
        await SDK.setUserProfile(profileName, ``, ``, ``, ``)
        const newUserProfile = await SDK.getUserProfile(formatUserIdToJid(data.username))
        console.log("Chat profile name", newUserProfile);
        if(newUserProfile && newUserProfile.statusCode === 200){
          store.dispatch(addVCardData(newUserProfile.data))
        }
      }else if(userProfile && userProfile.statusCode === 200){
        store.dispatch(addVCardData(userProfile.data))
      }

    const getFeatureList = await SDK.getAvailableFeatures()
    if(getFeatureList && getFeatureList.statusCode === 200){
      store.dispatch(addFeatureList(getFeatureList?.data))
    }
    const getFriendsList = await SDK.getUsersList("",1);
    if(getFriendsList && getFriendsList.statusCode === 200){
      store.dispatch(addRosterData([]))
    }
    const groupListRes = await SDK.getGroupsList();
      if (groupListRes && groupListRes.statusCode === 200) {
        groupListRes.data.map(async (group) => {
          const groupJid = formatUserIdToJid(group.groupId, CHAT_TYPE_GROUP);
          const groupPartRes = await SDK.getGroupParticipants(groupJid);
          if (groupPartRes && groupPartRes.statusCode === 200) {
            setGroupParticipantsByGroupId(groupJid, groupPartRes.data.participants);
          }
        });
        store.dispatch(addGroupsData(groupListRes.data));
      }
  
    const recentChatsRes = await SDK.getRecentChats();
    if (recentChatsRes && recentChatsRes.statusCode === 200) {
      store.dispatch(addRecentChat(recentChatsRes.data));
      muteStatus(recentChatsRes.data)
      unreadCountConstruction(recentChatsRes.data)
    }
    store.dispatch(addMirrorflyInitialData(true))
    if(customConversation?.conversationValue){
      const userJid = formatUserIdToJid(customConversation.userId);
      let response = await constructRosterData(userJid)
      let activeChatData = {
        chatId:customConversation.userId,
        chatJid:userJid,
        chatType: "chat",
        roster: response,
        recent: {
            chatType: "chat"
        }
      }
      store.dispatch(addActiveChatData(activeChatData))
    }
    setTimeout(() => {

      // this.setState({ webChatStatus: true }, async () => {
        // const urlPath = "bbl-hiyr-vhs";
        const urlPath = location?.href
        // // let lastValue = urlPath.lastIndexOf('/')
        // // let callLink = urlPath.substring(lastValue + 1);
        console.log("path",urlPath)
        // if (urlPath.length > 1 && callLink) {
        //   store.dispatch(addCallIntermediate({ show: true, link: callLink }));
        //   history.replaceState("", "", location?.origin)
        // }
      // });
    }, 100);
    createLocalDB("mf_inDB")
}

export const unreadCountConstruction = (unreadCountMessage) => {
  const unreadCountArray = unreadCountMessage.map((ele,ind)=>(
      {
        fromUserId : ele.fromUserId,
        unreadCount: ele.unreadCount
      }
  ))
  store.dispatch(addUnreadCount(unreadCountArray));
}

export const muteStatus = (chatMessages) => {
  chatMessages.map((chat)=>{
    const chatMute = chat.muteStatus === 1 ? true : false
    if (chatMute) setTempMute(chat.fromUserId, true);
  })
}